import * as t from "io-ts";
import { MailOrderTemplateDetail } from "dora-contracts";

/**
 * Wire codecs for `/api/mail-orders/**` live in `dora-contracts`
 * (`mail-orders.ts`) and are used directly by the duck.
 *
 * The one thing the contract deliberately leaves as `unknown` is a template's
 * `exampleOutput`: that is the mail-orders *draft*, a server-internal shape the
 * extraction pipeline owns, and the server re-validates it against its own
 * draft codec on every PUT. The mapping editor only addresses the two stop
 * lists and a handful of scalar fields, so we narrow it no further than that -
 * everything else (products, qualities, pieces, adr, coordinates) has to
 * survive a decode/edit/encode round trip untouched.
 */
export const mailOrderTemplateDraftT = t.intersection([
  t.type({
    pickups: t.array(t.UnknownRecord),
    dropoffs: t.array(t.UnknownRecord),
  }),
  t.UnknownRecord,
]);
export type MailOrderTemplateDraft = t.TypeOf<typeof mailOrderTemplateDraftT>;

/** A template detail whose `exampleOutput` has been narrowed for the editor. */
export type MailOrderTemplate = Omit<MailOrderTemplateDetail, "exampleOutput"> & {
  exampleOutput: MailOrderTemplateDraft;
};
